import { render, staticRenderFns } from "./emergencyMeasure.vue?vue&type=template&id=63bc8e68&scoped=true"
import script from "./emergencyMeasure.vue?vue&type=script&lang=js"
export * from "./emergencyMeasure.vue?vue&type=script&lang=js"
import style0 from "./emergencyMeasure.vue?vue&type=style&index=0&id=63bc8e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bc8e68",
  null
  
)

export default component.exports